import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { edrMutedStyle } from './edrTokens';

type SubscriptionUnavailableMessageProps = {
  messageKey: string;
  padded?: boolean;
};

export const SubscriptionUnavailableMessage: FC<SubscriptionUnavailableMessageProps> = ({
  messageKey,
  padded = false,
}) => {
  const { t } = useTranslation('securityEdr');

  return (
    <Box p={padded ? 3 : 0}>
      <Typography style={{ ...edrMutedStyle, fontSize: 13, fontStyle: 'normal' }}>
        {t(messageKey)}
      </Typography>
    </Box>
  );
};
